import { NgSignaturePadOptions, SignaturePadComponent } from '@almothafar/angular-signature-pad';
import {
    AfterViewInit,
    Component,
    ElementRef,
    forwardRef,
    HostListener,
    Inject,
    input,
    output,
    viewChild,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { WINDOW } from '@app/shared/services/window.token';
import { UntilDestroy } from '@ngneat/until-destroy';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@UntilDestroy({ checkProperties: true })
@Component({
    selector: 'app-signature-field',
    templateUrl: './signature-field.component.html',
    styleUrls: ['./signature-field.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SignatureFieldComponent),
            multi: true,
        },
    ],
    imports: [
        SignaturePadComponent,
        MatIconButton,
        MatTooltip,
        MatIcon,
        TranslateModule,
    ],
})
export class SignatureFieldComponent
    implements ControlValueAccessor, AfterViewInit
{
    public signaturePad = viewChild<SignaturePadComponent>('signature');

    signatureWrapper =
        viewChild<ElementRef<HTMLDivElement>>('signatureWrapper');

    public _signature: any = null;
    public propagateChange: Function;

    canvasWidth = input<number>(380);
    canvasHeight = input<number>(200);
    showTruck = input<boolean>(false);
    send = input<boolean>(false);
    clearSignature = input<boolean>(false);
    padId = input<string>('');
    showPullSignature = input<boolean>(false);
    signatureCleared = output<boolean>();
    signatureDrawCompleted = output<boolean>();
    signatureDrawStarted = output<boolean>();
    pullSignature = output<boolean>();

    canvas: HTMLCanvasElement;
    wrapper: any;

    @HostListener('window:resize', ['$event'])
    onResize(event: Event) {
        //  this.resizeCanvas();
    }

    loadSignature(): void {
        this.signaturePad()?.clear();
        this.pullSignature.emit(true);
    }

    public signaturePadOptions: NgSignaturePadOptions = {
        canvasWidth: this.canvasWidth(),
        canvasHeight: this.canvasHeight(),
    };
    constructor(
        public elRef: ElementRef,
        @Inject(WINDOW) public readonly window: any
    ) {
        this.window = window as Window;
    }

    ngAfterViewInit(): void {
        this.signaturePad()?.clear();
        // this.resizeCanvas();
    }

    get signature(): any {
        return this._signature;
    }

    set signature(value: any) {
        this._signature = value;
        if (typeof this.propagateChange === 'function') {
            this.propagateChange(this.signature);
        }
    }

    public writeValue(value: any): void {
        if (!value) {
            return;
        }
        this._signature = value;
        this.signaturePad()?.fromDataURL(this.signature);
    }

    public registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    public registerOnTouched(): void {
        // no-op
    }

    drawComplete(event: MouseEvent | Touch) {
        const pad = this.signaturePad();
        // Don't report an empty pad as a completed signature.
        if (!pad || pad.isEmpty()) {
            return;
        }
        this.signature = pad.toDataURL();
        this.signatureDrawCompleted.emit(true);
    }

    drawStart(event: MouseEvent | Touch) {
        this.signatureDrawStarted.emit(true);
    }

    public clear(): void {
        this.signaturePad()!.clear();
        this.signature = '';
        this.signatureCleared.emit(true);
    }

    private resizeCanvas() {
        this.signaturePadOptions.canvasWidth = this.signaturePadWidth() - 2;
        this.signaturePad()!.set('canvasWidth', this.signaturePadWidth() - 2);
    }

    private signaturePadWidth() {
        const width = this.signatureWrapper()!.nativeElement.offsetWidth;
        if (width < 250) {
            return 250;
        }

        return 350; //width; // DIGLIEF-2644
    }
}
